/* eslint-disable no-unused-vars */
import React from "react";
const bottomScripts = (listen = "load") => {
  let listener = `
     <script type="text/javascript">
        window.addEventListener('${listen}', function () {
          if (typeof _satellite !== 'undefined') {
            _satellite.track('window-onload');
          }
        });
        if (typeof _satellite !== 'undefined' && !window.dontLoadTarget) {
          _satellite.pageBottom();
        }
    </script> `;
  if (listen === "readystatechange") {
    listener = `
     <script type="text/javascript">
      document.addEventListener('readystatechange', function () {
        if (typeof _satellite !== 'undefined') {
          if(document.readyState === 'complete') {
              _satellite.track('window-onload');
          }
        }
      });
      if (typeof _satellite !== 'undefined' && !window.dontLoadTarget) {
        _satellite.pageBottom();
      }
    </script>`;
  }
  return `
    ${listener}
    <script>
     document.addEventListener('readystatechange', function () {
      if(document.readyState === 'loaded') {
      const scriptOee = document.createElement('script');
      scriptOee.async = true;
      scriptOee.onload = function() {
        ATGSvcs.setEEID("201902085120741");
        (function() {
          var l = 'lululemon.custhelp.com',d=document,ss='script',s=d.getElementsByTagName(ss)[0];
          function r(u) {
          var rn=d.createElement(ss);
          rn.type='text/javascript';
          rn.defer=rn.async=!0;
          rn.src = "//" + l + u;
          s.parentNode.insertBefore(rn,s);
          }
          r('/rnt/rnw/javascript/vs/1/vsapi.js');
          r('/vs/1/vsopts.js');
        })();
      }
      scriptOee.src = "https://static.atgsvcs.com/js/atgsvcs.js";
      document.head.appendChild(scriptOee);
           }
        });
    </script>
  `;
};
const BottomScripts = props => {
  const {
    listen = "load"
  } = props;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": "bottom-script",
    dangerouslySetInnerHTML: {
      __html: bottomScripts(listen)
    }
  });
};
export { bottomScripts, BottomScripts };